import {
  getValidAccessToken,
  isSessionActive,
  logout,
  SessionError,
  SESSION_LOGOUT_REASONS,
} from '@/services/auth/sessionService.js';

const isSafeMethod = (method = 'GET') => ['GET', 'HEAD', 'OPTIONS'].includes(method.toUpperCase());

const sendWithToken = async (input, init, token) => {
  init.signal?.throwIfAborted();
  if (!isSessionActive()) {
    throw new SessionError(SESSION_LOGOUT_REASONS.TOKEN_UNAVAILABLE);
  }

  const headers = new Headers(init?.headers);
  headers.set('Authorization', `Bearer ${token}`);
  const response = await fetch(input, { ...init, headers });
  init.signal?.throwIfAborted();
  if (!isSessionActive()) {
    throw new SessionError(SESSION_LOGOUT_REASONS.TOKEN_UNAVAILABLE);
  }
  return response;
};

export const authenticatedFetch = async (input, init = {}, { retryOnUnauthorized } = {}) => {
  init.signal?.throwIfAborted();
  if (!isSessionActive()) {
    throw new SessionError(SESSION_LOGOUT_REASONS.TOKEN_UNAVAILABLE);
  }

  const method = init.method ?? (input instanceof Request ? input.method : 'GET');
  const canReplay = retryOnUnauthorized ?? isSafeMethod(method);
  const token = await getValidAccessToken(false);
  const response = await sendWithToken(input, init, token);
  if (response.status !== 401) return response;

  const renewedToken = await getValidAccessToken(true);
  if (!isSessionActive()) {
    throw new SessionError(SESSION_LOGOUT_REASONS.TOKEN_UNAVAILABLE);
  }
  if (!canReplay) return response;

  const replayedResponse = await sendWithToken(input, init, renewedToken);
  if (replayedResponse.status === 401) {
    void logout({ reason: SESSION_LOGOUT_REASONS.AUTHENTICATION_REJECTED });
  }
  return replayedResponse;
};

export default authenticatedFetch;